// src/services/openai.js
// Simple wrapper calling the OpenAI Chat Completions endpoint.
// WARNING: in production do NOT call OpenAI directly from the browser with a secret API key.
// Proxy via your own backend instead.

// src/services/openai.js
// Auto-detect local vs production
const API_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5000/api/openai"
    : "/api/openai";


export async function queryOpenAI(prompt, model = "gpt-4o-mini") {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prompt, model })
  });

  if (!res.ok) {
    const errText = await res.text();
    throw new Error("Backend error: " + errText);
  }
// console.log("OPENAI_KEY:", process.env.OPENAI_KEY?.slice(0, 4) + "…");

  const json = await res.json();
  // console.log("OpenAI response JSON:", json);
  return json.choices?.[0]?.message?.content ?? "";
}

